import packages from "./packages.component";
import packagesUrls from "./packages.urls";
import PackagesTransforms from "./packages.transforms";

const packagesModule = angular
  .module("app.components.packages", [])
  .component("packagesPage", packages)
  .service("PackagesTransforms", PackagesTransforms)
  .config(packagesUrls);

export default packagesModule;



// WEBPACK FOOTER //
// ./src/pages/packages/packages.module.js